import { ChannelType, getChannelTypePicture } from "../../../../src/models/ChannelType";

/** Uses the same switched-light image as the main application's consumer toolbar. */
export function LightPaletteIcon({ group = false }: { group?: boolean }) {
  const image = getChannelTypePicture(ChannelType.Switch);
  if (!group) return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <image href={image} x="5" y="4" width="14" height="16" preserveAspectRatio="xMidYMid meet" />
    </svg>
  );
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {[{ x: 3, y: 2 }, { x: 13, y: 2 }, { x: 3, y: 13 }, { x: 13, y: 13 }].map(({ x, y }) => (
        <image key={`${x}-${y}`} href={image} x={x} y={y} width="8" height="9" preserveAspectRatio="xMidYMid meet" />
      ))}
    </svg>
  );
}
